import React from 'react';
import Layout from '../components/Layout';
import Landing from '../sections/Landing';
import About from '../sections/About';
import Projects from '../sections/Projects';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Loading from '../pages/Loading';
import NotFoundPage from './404';

import { Provider } from 'react-redux';
import { createStore as reduxCreateStore } from 'redux';
import rootReducer from '../redux/reducers';

import '../index.css';

const createStore = () => reduxCreateStore(rootReducer);
const store = createStore();

const IndexPage = () => {
  return (
    <Provider store={store}>
      <Layout>
        <Header />
        <Landing />
        <About />
        <Projects />
        <Footer />
      </Layout>
    </Provider>
  );
};

export default IndexPage;
